import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { KoboFieldService } from '../../kobo-field.service';
import { KoboService } from '../../kobo.service';
import { KoboCombinationConditionDialogComponent } from '../form-editor/kobo-combination/kobo-combination-condition-dialog/kobo-combination-condition-dialog.component';
import { KoboFormula } from '../form-editor/kobo-formula';
import { LocaleService } from "../../../locale.service";
import { SurveyModifierDialogComponent } from '../../../survey-modifier-dialog/survey-modifier-dialog.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-label-editor-detail',
    templateUrl: './label-editor-detail.component.html',
    styleUrls: ['./label-editor-detail.component.css'],
    standalone: false
})
export class LabelEditorDetailComponent implements OnInit {
  private readonly regularMode = 'hh-survey';

  private readonly repeatMode = 'repeat';

  @Input() formula:
    | {
        aggregatedName: string;
        aggregatedFields?: string[];
        fields: any;
        collectionName?: any;
        id?: number;
        formulaName: string;
        formulaDescription: string;
        formula: KoboFormula;
        kobo_surveys: any[];
      }
    | undefined;

  @Output() deleted = new EventEmitter<boolean>();

  selected: any | undefined;
  demoResults: any | undefined;
  fields: any | undefined;
  form: KoboFormula | undefined;
  selectedFields: any[] = [];

  constructor(
    public dialog: MatDialog,
    private koboService: KoboService,
    private fieldService: KoboFieldService,
    private localeService: LocaleService
  ) {
    this.myForm = new UntypedFormGroup({
      name: new UntypedFormControl(),
    });
    this.myForm.get('name')?.valueChanges.subscribe((updatedValue) => {
      console.log(updatedValue); // Access the updated value here
      if(this.formula && this.form){
        this.form.aggregatedName = updatedValue;
        console.log(this.formula)
      }
    });
  }
  myForm: UntypedFormGroup;
  
  ngOnInit(): void {
    this.localeService.updateLocale()
    if (this.formula) {
      this.form = this.formula.formula;
      this.fieldService.fieldObs.subscribe((fields) => {
        this.fields = fields;
      });
      this.fieldService.updateFields(this.formula!.kobo_surveys);

      console.log("loaded", this.formula)
      // Set the value of the 'name' form control
      this.myForm.get('name')?.setValue(this.form.aggregatedName || "");
    }
  }

  openAddConditionDialog(): void {
    const dialogRef = this.dialog.open(
      KoboCombinationConditionDialogComponent,
      {
        width: '80vw',
        data: {},
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (!this.form) return;
      if (result) {
        this.form.postProcessing!.conditions.push(result);
      }
    });
  }

  openFormulaModifierDialog(type: string) {
    if (!this.form) return;
    let dialogText;
    if(type == "changename"){
      dialogText = "Enter the new name for the formula:"
    }
    else if(type == "duplicate"){
      dialogText = "Enter a name for the copied formula:"
    }
    const dialogRef = this.dialog.open(SurveyModifierDialogComponent, {
      width: '35vw',
      data: {
        dialogText
      },
    });
    dialogRef.afterClosed().subscribe((newname) => {
      console.log(newname);
      if(this.formula){
        if(type=="changename"){
          this.formula.formulaName = newname;
          this.formula.formula.collectionName.display = newname;
          console.log(this.formula)
        }
        else if(type=="duplicate"){
          let new_formula = Object.assign({}, this.formula);
          new_formula.formulaName = newname;
          new_formula.formula.collectionName.display = newname;
          console.log(new_formula)
          const newKoboFormula = { // J: this weird format is expected by the backend
            collectionName: new_formula.collectionName,
            formulaName: new_formula.formulaName,
            formulaDescription: new_formula.formulaDescription,
            formula: this.buildFormulafromTemplate(new_formula.formula),
          };    
          console.log(newKoboFormula);
          if(true){
            this.koboService.createNewFormula(newKoboFormula).subscribe((response) => {
              console.log("created formula", response);
              new_formula.id = response.id;
              this.koboService.updateFormula(new_formula).subscribe((formula: any) => {
                this.formula = formula;
                this.form = this.formula!.formula;
              });
            });
          }
        }
      }
    });
  }

  updateAggregatedFields(newValue: string[]) {
    if(this.formula && this.form){
      this.form.aggregatedFields = newValue;
      console.log(this.formula)
    }
  }

  private buildFormulafromTemplate(new_formula: any) {
    const formula: KoboFormula = {
      collectionName: {
        collection: new_formula.collectionName,
        display: new_formula.name,
      },
      options: {},
      fields: [],
    };
    for (const field of new_formula.fields) {
      formula.fields.push({
        name: field.name,
        type: field.type.type,
        value: 1,
        conditions: [],
        divisor: []
      });
    }
    return formula;
  }

  executeOnDemoSet() {
    this.demoResults = undefined;
    this.koboService
      .executeFormulaOnDemoSet(this.selected, this.form)
      .subscribe((results) => {
        this.demoResults = results;
      });
  }

  saveFormula() {
    this.koboService.updateFormula(this.formula).subscribe((formula: any) => {
      this.formula = formula;
      this.form = this.formula!.formula;
      console.log("saved", formula)
    });
  }

  addPostprocessing() {
    if (!this.form) return;
    this.form.postProcessing = {
      operation: 'divide',
      conditions: [],
    };
  }
  removePostprocessing() {
    if (!this.form) return;
    delete this.form.postProcessing;
  }

  addAggregation() {
    if (!this.form) return;
    this.form.postAggregation = {
      operation: 'divide',
      conditions: [],
    };
  }

  removeAggregation() {
    if (!this.form) return;
    delete this.form.postAggregation;
  }

  changeMode(field: any) {
    if (field === '' && this.form) {
      if (!this.form.options) {
        this.form.options = { mode: this.regularMode };
      }
      if (this.form.options.mode === this.regularMode)
        this.form.options.mode = this.repeatMode;
      else this.form.options.mode = this.regularMode;
      return;
    }
    if (field.type === undefined || field.type === 'regular') {
      field.type = 'repeat';
    } else {
      field.type = 'regular';
    }
  }

  deleteFormula() {
    if (this.formula?.id)
      this.koboService.dropFormula(this.formula.id).subscribe((deleted) => {
        this.deleted.emit();
      });
  }

  resetLabels() {

  }

  changeLabel(eventData: any){
    console.log("changeLabel", eventData);
    const formulaIndex = this.form?.fields.findIndex((field) => field.name == eventData.fieldName);
    console.log("formulaIndex", this.form?.fields, formulaIndex);
    if(formulaIndex != undefined && formulaIndex>-1){
      const field = this.form?.fields[formulaIndex];
      console.log("field", field);
      if (field) {
        field.labels = eventData.inputValue;
      }
    }
  }
  
  selectFormField(fieldName: string){
    this.selectedFields.push(fieldName);
    console.log(fieldName);
    console.log(this.selectedFields)
    this.updateAggregatedFields(this.selectedFields);
  }

  unselectFormField(fieldName: string){
    const index = this.selectedFields.find(f => f==fieldName);
    if(index != -1){
      this.selectedFields.splice(index, 1); 
    }
    console.log(fieldName);
    console.log(this.selectedFields)
    this.updateAggregatedFields(this.selectedFields);
  }

}
